export const environment = {
  production: true,
};
export const env = 'Dev';
export const websocketServer =
  'wss://apis.horatech.com.ar/agro-v2-websocket-dev';
export const apiBase = 'https://apis.horatech.com.ar/agro-v2-cliente-dev';
